'use client'

import { createContext, ReactNode } from 'react'
import { LinkData } from './link-data'

type ContextType = (props: LinkData) => ReactNode

export const LinkProvider = createContext<ContextType>((props) => <a {...props} data-sf-unstyled="link" />)
